import api from '@/backend/api'

export default {
    /**
     GET   /api/auth/start
     */
    async start(params = null) {
        return await api.get('auth/start', '', params)
    },
    /**
     GET   /api/auth/ping
     */
    async ping() {
        return await api.get('auth/ping')
    },
    /**
     GET   /api/auth/login-url
     */
    async getLoginData(params = null) {
        try {
            const result = await api.get('auth/login-url', params);
            return result;
        } catch (err) {
            console.error('getLoginData error:', err, params);
            throw err;
        }
    },
    async deleteLoginCookie() {
        return await api.get('auth/deleteLoginCookie')
    },
    async getLogoutCookie() {
        return await api.get('authenticate/logoutCookie')
    }
}